window.kimoRememberPosition = function (dialog, origin) {
  if (dialog.open) return;
  var positions = [];
  for (var node = origin; node; node = node.parentElement) {
    positions.push({node: node, top: node.scrollTop, left: node.scrollLeft});
  }
  var x = window.scrollX || 0;
  var y = window.scrollY || 0;
  dialog.addEventListener('close', function restore() {
    if (dialog.open) return;
    positions.forEach(function (position) {
      if (position.node.isConnected) {
        position.node.scrollTop = position.top;
        position.node.scrollLeft = position.left;
      }
    });
    window.scrollTo({left: x, top: y, behavior: 'instant'});
  }, {once: true});
};

(function () {
  var revealElements = document.querySelectorAll('.reveal');

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    revealElements.forEach(function (element) {
      observer.observe(element);
    });
  } else {
    revealElements.forEach(function (element) {
      element.classList.add('in');
    });
  }

  var header = document.querySelector('[data-header]');
  var previousScrollPosition = window.scrollY || 0;
  var headerFrame = null;

  window.addEventListener('scroll', function () {
    if (!header || headerFrame !== null) return;
    headerFrame = window.requestAnimationFrame(function () {
      headerFrame = null;
      var currentScrollPosition = Math.max(0, window.scrollY || 0);
      if (Math.abs(currentScrollPosition - previousScrollPosition) < 8 && currentScrollPosition > 160) return;
      header.classList.toggle('hide', currentScrollPosition > previousScrollPosition && currentScrollPosition > 160);
      previousScrollPosition = currentScrollPosition;
    });
  }, { passive: true });

  function formatNumber(number) {
    return String(number).padStart(2, '0');
  }

  function closeOpenProcessBook() {
    var openDialog = document.querySelector('.process-dialog[open]');
    if (openDialog) {
      openDialog.close();
    }
  }

  document.querySelectorAll('.process-dialog').forEach(function (dialog) {
    var viewport = dialog.querySelector('[data-process-viewport]');
    var slides = Array.prototype.slice.call(dialog.querySelectorAll('[data-process-slide]'));
    var previousButton = dialog.querySelector('[data-process-prev]');
    var nextButton = dialog.querySelector('[data-process-next]');
    var closeButton = dialog.querySelector('[data-process-close]');
    var counter = dialog.querySelector('[data-process-counter]');
    var pdfUrl = dialog.getAttribute('data-process-pdf');
    var currentIndex = 0;
    var scrollFrame = null;
    var pdfDocument = null;
    var pdfPromise = null;
    var renderedPages = {};
    var renderPromises = {};
    var wheelLocked = false;

    function markPdfError(index) {
      var slide = slides[index];
      if (!slide) return;
      slide.classList.remove('is-ready');
      slide.classList.add('is-error');
    }

    function getPdfDocument() {
      if (!pdfUrl) return Promise.resolve(null);
      if (pdfDocument) return Promise.resolve(pdfDocument);
      if (pdfPromise) return pdfPromise;

      if (!window.pdfjsLib) {
        return Promise.reject(new Error('PDF reader unavailable'));
      }

      if (window.KIMO_PDF_WORKER_URL) {
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = window.KIMO_PDF_WORKER_URL;
      }

      pdfPromise = window.pdfjsLib.getDocument({
        url: pdfUrl,
        isEvalSupported: false
      }).promise.then(function (documentHandle) {
        pdfDocument = documentHandle;
        return documentHandle;
      });

      return pdfPromise;
    }

    function renderPdfPage(index) {
      if (!pdfUrl || renderedPages[index] || renderPromises[index] || !slides[index]) return;

      var slide = slides[index];
      var canvas = slide.querySelector('.process-canvas');
      if (!canvas) return;

      renderPromises[index] = getPdfDocument()
        .then(function (documentHandle) {
          return documentHandle.getPage(index + 1);
        })
        .then(function (page) {
          var baseViewport = page.getViewport({ scale: 1 });
          var horizontalPadding = window.innerWidth <= 800 ? 16 : 32;
          var verticalPadding = window.innerWidth <= 800 ? 24 : 40;
          var maxWidth = Math.max(280, viewport.clientWidth - horizontalPadding);
          var maxHeight = Math.max(320, viewport.clientHeight - verticalPadding);
          var cssScale = Math.min(maxWidth / baseViewport.width, maxHeight / baseViewport.height);
          var pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
          var renderViewport = page.getViewport({ scale: cssScale * pixelRatio });
          var context = canvas.getContext('2d', { alpha: false });

          canvas.width = Math.ceil(renderViewport.width);
          canvas.height = Math.ceil(renderViewport.height);
          canvas.style.width = Math.ceil(renderViewport.width / pixelRatio) + 'px';
          canvas.style.height = Math.ceil(renderViewport.height / pixelRatio) + 'px';

          return page.render({
            canvasContext: context,
            viewport: renderViewport,
            background: '#ffffff'
          }).promise;
        })
        .then(function () {
          renderedPages[index] = true;
          slide.classList.remove('is-error');
          slide.classList.add('is-ready');
        })
        .catch(function () {
          markPdfError(index);
        })
        .finally(function () {
          delete renderPromises[index];
        });
    }

    function renderNearbyPages(index) {
      [index, index + 1, index - 1].forEach(function (pageIndex) {
        var image = slides[pageIndex] && slides[pageIndex].querySelector('img');
        if (!image) return;
        image.loading = 'eager';
        image.fetchPriority = pageIndex === index ? 'high' : 'low';
        if (image.decode) image.decode().catch(function () {});
      });
      renderPdfPage(index);
      renderPdfPage(index + 1);
      renderPdfPage(index - 1);
    }

    function updateControls() {
      dialog.setAttribute('data-process-index', String(currentIndex));

      if (counter) {
        counter.textContent = formatNumber(currentIndex + 1) + ' / ' + formatNumber(slides.length);
      }

      if (previousButton) {
        previousButton.disabled = currentIndex === 0;
      }

      if (nextButton) {
        nextButton.disabled = currentIndex === slides.length - 1;
      }
    }

    function goToPage(index, behavior) {
      currentIndex = Math.max(0, Math.min(index, slides.length - 1));
      viewport.scrollTo({
        left: currentIndex * viewport.clientWidth,
        behavior: 'instant'
      });
      updateControls();
      renderNearbyPages(currentIndex);
    }

    dialog.resetProcessBook = function () {
      currentIndex = 0;
      viewport.scrollLeft = 0;
      dialog.querySelectorAll('.process-page').forEach(function (page) { page.scrollTop = 0; page.scrollLeft = 0; });
      updateControls();
      renderNearbyPages(0);
    };

    previousButton.addEventListener('click', function () {
      goToPage(currentIndex - 1, 'smooth');
    });

    nextButton.addEventListener('click', function () {
      goToPage(currentIndex + 1, 'smooth');
    });

    var readingButton = dialog.querySelector('[data-process-reading]');
    if (readingButton) {
      readingButton.addEventListener('click', function () {
        var reading = dialog.classList.toggle('is-reading');
        readingButton.setAttribute('aria-pressed', String(reading));
        readingButton.textContent = readingButton.getAttribute(reading ? 'data-label-fit' : 'data-label-larger');
        dialog.querySelectorAll('.process-page').forEach(function (page) {
          page.scrollTop = 0;
          page.scrollLeft = 0;
        });
      });
    }

    closeButton.addEventListener('click', function () {
      dialog.close();
    });

    viewport.addEventListener('scroll', function () {
      if (scrollFrame !== null) {
        window.cancelAnimationFrame(scrollFrame);
      }

      scrollFrame = window.requestAnimationFrame(function () {
        if (viewport.clientWidth > 0) {
          var visibleIndex = Math.max(0, Math.min(Math.round(viewport.scrollLeft / viewport.clientWidth), slides.length - 1));
          if (visibleIndex !== currentIndex) {
            currentIndex = visibleIndex;
            updateControls();
            renderNearbyPages(currentIndex);
          }
        }
        scrollFrame = null;
      });
    }, { passive: true });

    viewport.addEventListener('wheel', function (event) {
      if (dialog.hasAttribute('data-mobile-readable') || dialog.classList.contains('is-reading')) return;
      if (Math.abs(event.deltaY) < 24 || Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

      var direction = event.deltaY > 0 ? 1 : -1;
      var nextIndex = currentIndex + direction;
      if (nextIndex < 0 || nextIndex >= slides.length) return;

      event.preventDefault();
      if (wheelLocked) return;

      wheelLocked = true;
      goToPage(nextIndex, 'smooth');
      window.setTimeout(function () {
        wheelLocked = false;
      }, 450);
    }, { passive: false });

    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goToPage(currentIndex - 1, 'smooth');
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goToPage(currentIndex + 1, 'smooth');
      }
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        dialog.close();
      }
    });

    dialog.addEventListener('close', function () {
      document.body.classList.remove('process-book-open');
      if (dialog.processBookTrigger) {
        dialog.processBookTrigger.focus({preventScroll: true});
      }
    });

    window.addEventListener('resize', function () {
      if (dialog.open) {
        goToPage(currentIndex, 'auto');
      }
    });

    updateControls();
  });

  document.querySelectorAll('[data-process-open]').forEach(function (button) {
    button.addEventListener('click', function (event) {
      var dialogId = button.getAttribute('data-process-open');
      var dialog = document.getElementById(dialogId);

      if (!dialog) return;
      if (button.tagName === 'A') event.preventDefault();

      closeOpenProcessBook();
      dialog.processBookTrigger = button;
      window.kimoRememberPosition(dialog, button);

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }

      document.body.classList.add('process-book-open');

      window.requestAnimationFrame(function () {
        dialog.resetProcessBook();
        var viewport = dialog.querySelector('[data-process-viewport]');
        if (viewport) viewport.focus({preventScroll: true});
      });
    });
  });

  var processParams = new URLSearchParams(window.location.search);
  var artworkView = processParams.get('view') || '';
  if (processParams.get('process') === '1' && /^art-[a-z0-9-]+$/.test(artworkView)) {
    var directBookId = 'process-' + artworkView.slice(4);
    var directBookTrigger = document.querySelector('[data-process-open="' + directBookId + '"]');
    if (directBookTrigger && document.getElementById(directBookId)) directBookTrigger.click();
  }
})();

(function () {
  var selector = '.shop-button,.pdf-link.process-open,.process-download,.process-arrow,.process-close,.notify-close,.drop-shop-close,.alerts-fields button';
  document.querySelectorAll(selector).forEach(function (button) {
    var duration = 9 + Math.random() * 9;
    button.style.setProperty('--kimo-flicker-duration', duration.toFixed(3) + 's');
    button.style.setProperty('--kimo-flicker-delay', (-Math.random() * duration).toFixed(3) + 's');
  });
})();
